import React from 'react';

import './SpinnerSymulator.scss';

const SpinnerSymulator = ({ children, className = '', ...props }) => {
    return (
        <div {...props} className={`spinner-symulator ${className}`}>
            <div className="symulator-logo">
                <div className="square"></div>
                <div className="square"></div>
                <div className="square"></div>
                <div className="square"></div>
            </div>
            <div>{children}</div>
        </div>
    );
}

export default SpinnerSymulator;